import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import DateInput from "components/DateInput";
import Switch from "components/Switch";

import { DropdownGlobal } from "../../../../../components/DropdownGlobal";
import { AttendantRoleService } from "../../../../../services/attendantRole";
import DateValidate from "../../../../../utils/dateValidate";
import {
  AccessValidated,
  ContainerFormOneLabelSwitch,
  ContainerVaras,
} from "../styles";

interface UserCreateProps {
  currentSelectedType?: any;
  customerId?: any;
  setProfileId: (id: number) => unknown;
  setUnitLabel: (value: any) => void;
  expiredDate: any;
  setExpiredDate: (date: any) => unknown;
  active: boolean;
  onChangeSwitch: (value: any) => void;
  onSelectType: (value: any) => void;
  setProfileLabel: (value: any) => void;
  userId?: any;
  isEditCreated: boolean;
  unitLabel?: string;
  isEdit: boolean;
  profileLabel: string | undefined;
  selectedType: number | undefined;
  setSelectedType: (e: number | undefined) => void;
  setCourtLabel: (e: string | undefined) => void;
  setCourtId: (e: number | undefined) => void;
  courtLabel: string | undefined;
  userIdEdit: number;
  requiredCourt: boolean;
  requiredUnit: boolean;
  requiredProfile: boolean;
  setUnitOptions: (e: any) => void;
}

export function FormVinculeUnit(props: UserCreateProps) {
  const { t } = useTranslation();
  const [newData, setNewData] = useState<any[]>([]);
  const [listProfiles, setListProfiles] = useState<any[]>([]);
  const [loadingProfiles, setLoadingProfiles] = useState(false);

  const isUserId = props.userIdEdit ?? undefined;
  const type = props?.selectedType ?? undefined;

  async function getDataUnit() {
    const { data } = await AttendantRoleService.getAllPlace(
      props?.customerId,
      props.userId!,
    );
    const options = data?.data?.filter((item: any) => item.active);
    setNewData(options);
  }

  const getProfiles = async () => {
    try {
      setLoadingProfiles(true);
      const alive = true;

      const req = AttendantRoleService.getAllByCustomerId2(
        props?.customerId,
        isUserId,
        type,
      );

      const { body, status } = await req;
      if (!alive) return;

      if (!body) {
        props.setUnitOptions([]);
        setListProfiles([]);
      } else {
        props.setUnitOptions(
          props.selectedType === 1 ? body : (body[0]?.districts ?? []),
        );
        if (status) setListProfiles(body ?? []);
      }
    } catch (error) {
      props.setUnitOptions([]);
      setListProfiles([]);
    } finally {
      setLoadingProfiles(false);
    }
  };

  useEffect(() => {
    getDataUnit();
  }, []);

  useEffect(() => {
    setListProfiles([]);
    if (props.selectedType !== undefined) getProfiles();
  }, [props.selectedType, props.currentSelectedType]);

  const unitOption = () => {
    if (props.selectedType === undefined) return [];
    return props.selectedType === 1
      ? listProfiles
      : (listProfiles?.[0]?.districts ?? []);
  };

  const filteredDistrict = (districts: any[]) => {
    if (!districts) return [];
    const found = districts.find((d: any) => d.name === props.unitLabel);
    return found ? found.courts : [];
  };

  const showCourts = props.selectedType === 0 && !!props.unitLabel;

  const districts = listProfiles?.[0]?.districts ?? [];
  const courtsFromSelectedDistrict = filteredDistrict(districts);

  const canChooseCourts =
    props.selectedType === 0 &&
    !!props.unitLabel &&
    courtsFromSelectedDistrict.length > 0;

  const courtsPlaceholder =
    props.selectedType !== 0
      ? t("units.profileNoVaras")
      : !props.profileLabel || !props.unitLabel
        ? t("units.selectProfileAndCounty")
        : courtsFromSelectedDistrict.length === 0
          ? t("units.noVarasAvailable")
          : t("common.select");

  return (
    <ContainerVaras>
      <ContainerFormOneLabelSwitch>
        <Switch
          dataTest="switch_active"
          checked={props.active}
          onChange={() => props.onChangeSwitch(!props.active)}
          label={t("common.active")}
        />
      </ContainerFormOneLabelSwitch>

      <DropdownGlobal
        labelName={t("labels.profile")}
        wantAnObject
        options={newData}
        error={props.requiredProfile}
        required
        editDropdown={t("common.select")}
        defaultValue={props.profileLabel ?? t("common.select")}
        showDefaultValue
        width="100%"
        setSelected={(item: any) => {
          props.setSelectedType(item.type);
          props.setProfileLabel(item.name);
          props.setProfileId(item.id);
          props.setUnitLabel(undefined);
          props.onSelectType(undefined);
          props.setCourtLabel(undefined);
          props.setCourtId(undefined);
        }}
      />

      <DropdownGlobal
        labelName={
          props.selectedType === 1 ? t("units.title") : t("labels.counties")
        }
        wantAnObject
        options={unitOption()}
        error={props.requiredUnit}
        required
        editDropdown={t("common.select")}
        defaultValue={props.unitLabel ?? t("common.select")}
        showDefaultValue
        disabled={loadingProfiles}
        // disabled={(props.isEdit && props.isEditCreated) || loadingProfiles}
        width="100%"
        setSelected={(selectedItem: any) => {
          props.setUnitLabel(selectedItem?.name);
          props.onSelectType(selectedItem?.id);
          props.setCourtLabel(undefined);
          props.setCourtId(undefined);
        }}
      />

      {showCourts && (
        <DropdownGlobal
          labelName={t("labels.courts")}
          wantAnObject
          options={courtsFromSelectedDistrict}
          error={props.requiredCourt}
          required
          editDropdown={courtsPlaceholder}
          defaultValue={props.courtLabel ?? t("common.select")}
          disabled={!canChooseCourts}
          // disabled={!canChooseCourts || (props.isEdit && props.isEditCreated)}
          showDefaultValue
          width="100%"
          setSelected={(selectedItem: any) => {
            props.setCourtLabel(selectedItem?.name);
            props.setCourtId(selectedItem?.id);
          }}
        />
      )}

      <AccessValidated>
        <DateInput
          label={t("labels.expirationDate")}
          setValue={(date: any) => props.setExpiredDate(date)}
          value={props.expiredDate}
          error={DateValidate(props.expiredDate)}
        />
      </AccessValidated>
    </ContainerVaras>
  );
}
